import React from 'react'
import { compose, withPropsOnChange } from 'recompose'
import { connect } from 'react-redux'
import { change } from 'redux-form'
import get from 'lodash/get'
import map from 'lodash/map'
import {
  EQUIPMENTS_SCHEMA_NAME,
  equipmentsApiActions, equipmentsEntitiesSelector,
} from 'api/equipments'
import { createAutoCompleteComponent } from 'components/Autocomplete'
import './equipment-auto-complete.scss'

const itemComponentFields = [
  {
    title: `Название`,
    path : `info`,
  },
  {
    title: `Адрес`,
    path : `address2`,
  },
  {
    title: `Техническое место`,
    path : `tech_place.link.value`,
  },
]

const ItemComponentField = ({ item, path }) => {
  const value = get(item, path)

  if (!value) {
    return ``
  }

  return (
    <div>
      {value}
    </div>
  )
}

export const ItemComponent = ({ item }) => (
  <div className='equipment-select-item'>
    {
      map(itemComponentFields, ({ path, title }) => (
        <ItemComponentField
          item={item}
          path={path}
          title={title}
          key={path}
        />
      ))
    }
  </div>
)

const EquipmentAutoComplete = createAutoCompleteComponent({
  entity          : EQUIPMENTS_SCHEMA_NAME,
  apiActionByValue: equipmentsApiActions.getEquipmentByCode,
  apiActionByText : equipmentsApiActions.searchEquipmentsByDispatchingName,
  valueField      : `code`,
  textField       : `info`,
  multiple        : false,
  itemComponent   : ItemComponent,
})

const enhancer = compose(
  connect((state) => ({
    equipments: equipmentsEntitiesSelector(state),
  }), (dispatch, { meta: { form } }) => ({
    changeFormValue: (field, value) => dispatch(change(form, field, value)),
  })),
  withPropsOnChange([`input`], ({
    equipments,
    input: { value },
    changeFormValue,
  }) => {
    const {
      dispatching_name: dispatchingName,
      voltage,
    } = get(equipments, value, {})
    changeFormValue(`object`, dispatchingName)
    changeFormValue(`objectClass`, voltage)
  }),
)

export default enhancer(EquipmentAutoComplete)
